/* global G */

/**
 * Duplicate Customer Number Error Dialog
 *
 * Displays an error informing the user that they are not allowed to input a duplicate customer number.
 *
 * @param {Gaia.Web.Application} obj  the Web platform Application
 */
export default (obj) => {
  const eventBus = obj[G.ADAPTER][G.EVENTS]

  eventBus.dispatch(eventBus.type(G.DATA, G.UNDO), {
    title: obj[G.ADAPTER][G.INTL]._t(
      'dialog.error.duplicateCustomerNumber.title',
      {
        ns: 'common',
        _key: 'dialog.error.duplicateCustomerNumber.title',
        defaultValue: 'Duplicate customer number',
      },
    ),
    text: obj[G.ADAPTER][G.INTL]._t(
      'dialog.error.duplicateCustomerNumber.text',
      {
        ns: 'common',
        _key: 'dialog.error.duplicateCustomerNumber.text',
        defaultValue: 'The entered number is already registered with another customer. Please check this, reset the number if necessary, and repeat the process',
      },
    ),
    children: {
      ok: {
        key: 'ok',
        value: obj[G.ADAPTER][G.INTL]._t(
          'button.ok',
          {
            ns: 'common',
            _key: 'button.ok',
            defaultValue: 'Ok',
          },
        ),
      },
    },
  })
}
